/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-else-return */
import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useAPIError from '../../hooks/useAPIError';
import useDatalayerEvents from '../../hooks/useDatalayerEvents';
import useSessionChecking from '../../hooks/useSessionChecking';
import i18n from '../../i18n';
import SaldoService from '../../services/SaldoService';
import { useAppStore } from '../../store/AppContext';
import { useAuthStore } from '../../store/AuthContext';
import { SaldoData } from '../../types/Types';
import { BackMappings } from '../../utils/BackMappings';
import { GtmConstants } from '../../utils/GtmConstants';
import { HostProvider } from '../../utils/HostProvider';
import { StorageHelper } from '../../utils/StorageHelper';
import NotFound from '../NotFound';
import SaldoCaprabo from './indexCaprabo';
import SaldoEroski from './indexEroski';

const Saldo: FC = () => {
  const isCaprabo = HostProvider.isCaprabo();
  const isEroski = HostProvider.isEroski();

  const [goOn, setGoOn] = useState<boolean>(false);
  StorageHelper.setOrigin(BackMappings.SALDO);
  useSessionChecking(BackMappings.SALDO, setGoOn, goOn);
  useDatalayerEvents(GtmConstants.MIS_VENTAJAS);

  const { t } = useTranslation();
  const dataUser = useAuthStore();
  const [saldoData, setSaldoData] = useState<SaldoData[]>([]);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [totalElements, setTotalElements] = useState(0 as number);
  const [ahorrado, setAhorrado] = useState(0 as number);
  const [load, setLoad] = useState(false as boolean);
  const [view, setView] = useState(false as boolean);
  const [backError, setBackError] = useState(false as boolean);
  const dataApp = useAppStore();
  const [firstCharge, setFirstCharge] = useState(true);
  const { addError, addErrorBack } = useAPIError();

  const retrieveSaldo = (page = 1 as number) => {
    const data = {
      pageNumber: page,
    };
    SaldoService.retrieveSaldo(data)
      .then((response) => {
        if (response.data.error === true) {
          if (firstCharge) {
            addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'KO');
          }
          setView(true);
          setBackError(true);
          addErrorBack(response.data);
        } else {
          setLoad(true);
          setView(true);
          setFirstCharge(false);
          if (typeof response.data.pojos !== 'undefined')
            setSaldoData(response.data.pojos);
          if (typeof response.data.totalElements !== 'undefined')
            setTotalElements(response.data.totalElements);
          if (typeof response.data.saldoUsuario !== 'undefined')
            setAhorrado(response.data.saldoUsuario);
        }
      })
      .catch((e) => {
        console.log(e);
        addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'WARNING');
      });
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (dataUser.user.token !== '') {
      if (!load) {
        setLoad(true);
        retrieveSaldo();
      }
    }
  });

  useEffect(() => {
    if (dataUser.user.token !== '') retrieveSaldo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n.language]);

  if (goOn) {
    if (view) {
      if (isEroski) {
        return (
          <>
            <SaldoEroski
              dataUser={dataUser}
              ahorrado={ahorrado}
              view={view}
              dataApp={dataApp}
              backError={backError}
              saldoData={saldoData}
            />
          </>
        );
      } else if (isCaprabo) {
        return (
          <>
            <SaldoCaprabo
              dataUser={dataUser}
              ahorrado={ahorrado}
              view={view}
              dataApp={dataApp}
              backError={backError}
              saldoData={saldoData}
            />
          </>
        );
      }
      return <NotFound />;
    }
    return <></>;
  }
  return <></>;
};

export default Saldo;
